import {React} from 'react';
import {generatePath, Link} from 'react-router-dom';
import {FormattedMessage, useIntl} from 'react-intl';
import {
  Button,
  makeStyles,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import messages from '@super-template/messages';
import {addWeeks, format, isBefore} from 'date-fns';
import useLocale from '@super-template/core/src/locale/useLocale';
import {path as info} from '../../info';
import getTranslated from "@super-template/core/src/locale/getTranslated";

const useStyles = makeStyles((theme) => ({
  root: {
    '& .divider': {
      whiteSpace: 'nowrap',
      display: 'block',
    },
    '& .hidden-sm': {
      display: 'table-cell',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& .hidden-md': {
      display: 'table-cell',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },
}));

export const expiring = (date) => isBefore(new Date(date), addWeeks(new Date(), 1));

export default function DesktopTable({primary, summary, wishes, showPartner, array, selectPrimary, actionRemove, organization, isHolidayOrganization}) {
  const classes = useStyles();
  const intl = useIntl();
  const [locale] = useLocale();
  const state = window.location.search;

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table size="small" id={"holidayTable"}
             aria-label={intl.formatMessage(messages[isHolidayOrganization ? 'holidays_select' : 'courses_select'])}>
        <TableHead className={classes.head}>
          <TableRow>
            {primary && (
              <TableCell>
                <Typography variant={"srOnly"}>
                  <FormattedMessage {...isHolidayOrganization ? messages.primary_wish : messages.primary_course} />
                </Typography>
              </TableCell>)}
            <TableCell><FormattedMessage {...messages.date} /></TableCell>
            <TableCell><FormattedMessage {...messages.theme} /></TableCell>
            {showPartner &&
            <TableCell className={'hidden-md'}><FormattedMessage {...messages.partner} /></TableCell>}
            <TableCell><FormattedMessage {...messages.target} /></TableCell>
            {!summary &&
            <>
              <TableCell className={'hidden-sm'}><FormattedMessage {...messages.search_end_date} /></TableCell>
              <TableCell><FormattedMessage {...messages.action} /></TableCell>
            </>}
          </TableRow>
        </TableHead>
        <TableBody>
          {array.map(({id, ...row}) =>
            <TableRow key={id}>
              {primary &&
              <>
                {summary ?
                  <TableCell>
                    {id === primary.id && <FormattedMessage {...messages.primary} />}
                  </TableCell> :
                  <TableCell padding="checkbox" style={{whiteSpace: 'nowrap'}}>
                    <Radio checked={id === primary.id} value={id.toString()} onChange={selectPrimary}
                           name={isHolidayOrganization ? 'primary_wish' : 'primary_course'}
                           inputProps={{'aria-label': intl.formatMessage(messages[isHolidayOrganization ? 'primary_wish' : 'primary_course'])}}/>
                    {id === primary.id && <>{' '}<FormattedMessage {...messages.primary} /></>}
                  </TableCell>}
              </>}
              <TableCell>
                {format(new Date(row.startDate), 'dd.MM.yyyy')}{' - '}{format(new Date(row.endDate), 'dd.MM.yyyy')}
              </TableCell>
              <TableCell>{getTranslated(row.themeName, locale)}</TableCell>
              {showPartner &&
              <TableCell className={'hidden-md'}>
                {row.partnerOrganization?.www ?
                  <a target={'_blank'} rel="noreferrer" href={row.partnerOrganization.www}>
                    {row.partnerOrganization.name}
                  </a> : row.partnerOrganization?.name}
              </TableCell>}
              <TableCell>{row.resortOrganization.name}</TableCell>
              {!summary &&
              <>
                <TableCell className={`hidden-sm ${expiring(row.applicationEndDate) && 'warn'}`}>
                  {format(new Date(row.applicationEndDate), 'dd.MM.yyyy')}
                </TableCell>
                <TableCell>
                  {!wishes &&
                  <Link to={{pathname: generatePath(info, {organization, id}), state}} className={'MuiButton-root as-link'}>
                    <FormattedMessage {...messages.open_holiday} />
                    <Typography variant={'srOnly'}>
                      {isHolidayOrganization ?
                        <FormattedMessage {...messages.read_holiday} values={{to: row.resortOrganization.name}}/> :
                        <FormattedMessage {...messages.read_course} values={{to: row.resortOrganization.name}}/>}
                    </Typography>
                  </Link>}
                  {primary &&
                  <Button color="primary" onClick={() => actionRemove({id})} className={'divider as-link'}>
                    <FormattedMessage {...messages.remove_wish} />
                    <Typography variant={'srOnly'}>
                      {isHolidayOrganization ?
                        <FormattedMessage {...messages.read_holiday} values={{to: row.resortOrganization.name}}/> :
                        <FormattedMessage {...messages.read_course} values={{to: row.resortOrganization.name}}/>}
                    </Typography>
                  </Button>}
                </TableCell>
              </>}
            </TableRow>)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
